export default __webpack_public_path__ + "static/media/step_6_assign_device.abb6acd3.png";